import React from 'react';
import { ClusterPageTemplate } from '../components/ClusterPageTemplate';
export function ClusterGaragePage() {
  return <ClusterPageTemplate clusterName="Garage" sectorName="Lokale Retail & Dienstverlening" sectorSlug="lokale-retail" heroTitle="Website laten maken voor een autogarage" heroDescription="Een betrouwbare, conversiegerichte website voor jouw garagebedrijf. Wij bouwen websites die lokaal goed gevonden worden en de werkplaats vullen." websiteOnderdelen={[{
    icon: 'WrenchIcon',
    title: 'Dienstenoverzicht',
    description: "Heldere pagina's voor APK, grote/kleine beurt, aircoservice, bandenwissel en storingsdiagnose."
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Werkplaats afspraak',
    description: 'Een prominente module waar klanten 24/7 online een afspraak kunnen inplannen voor onderhoud.'
  }, {
    icon: 'CarIcon',
    title: 'Occasions (optioneel)',
    description: "Een overzichtelijke presentatie van jullie actuele aanbod aan tweedehands auto's."
  }, {
    icon: 'StarIcon',
    title: 'Reviews & Keurmerken',
    description: 'Toon BOVAG-schilden, RDW-erkenning en klantbeoordelingen om direct vertrouwen te wekken.'
  }]} functionaliteiten={[{
    icon: 'CalendarCheckIcon',
    title: 'Afspraakplanner',
    description: 'Koppeling met garage-software (zoals Carsys of WESP) of een eigen planningsformulier.'
  }, {
    icon: 'PhoneIcon',
    title: 'Pechhulp / Click-to-call',
    description: 'Een opvallende bel-knop op mobiel voor klanten die met pech langs de weg staan.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokale SEO',
    description: "Geoptimaliseerd voor zoektermen als 'APK keuring [jouw stad]' en 'auto reparatie'."
  }]} siblingClusters={[{
    name: 'Kapsalon',
    slug: 'kapsalon'
  }, {
    name: 'Fietsenwinkel',
    slug: 'fietsenwinkel'
  }, {
    name: 'Autobedrijf',
    slug: 'autobedrijf'
  }]} faqs={[{
    q: 'Kunnen klanten online een APK inplannen?',
    a: 'Ja, we kunnen een afspraakmodule inbouwen of linken naar de planningsmodule van jullie bestaande garage-software.'
  }, {
    q: 'Kan ik ook mijn occasions op de website tonen?',
    a: 'Zeker. We kunnen een koppeling maken met systemen zoals Wheelerdelta of VWE, zodat je aanbod automatisch op de site verschijnt.'
  }, {
    q: 'Wat kost een website voor een garagebedrijf?',
    a: 'Een professionele website start vanaf €1.500. Voor een website inclusief automatische occasion-koppeling maken we een offerte op maat.'
  }, {
    q: 'Hoe zorg ik dat ik gevonden word voor specifieke diensten?',
    a: "We maken aparte, SEO-geoptimaliseerde landingspagina's voor je belangrijkste diensten (bijv. 'Aircoservice Alkmaar' of 'Bandenwissel')."
  }]} data-id="element-1082" />;
}